// Membership badge pill rendered next to a counterparty's username.
// Shared between Matches.jsx and the UserGroupCard component (which is in
// turn used on Matches/SavedMatches/HiddenMatches). Returns null for any
// tier other than premium_basic / premium_plus.
export function getMembershipBadge(membershipTier) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 9px',
    borderRadius: '9999px',
    fontFamily: 'Nunito, sans-serif',
    fontSize: '0.75rem',
    fontWeight: '700',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap'
  };
  switch (membershipTier) {
    case 'premium_basic':
      return (
        <div style={{ ...base, backgroundColor: '#DBEAFE', color: '#1E40AF' }}>
          ⚡ 9V Member
        </div>
      );
    case 'premium_plus':
      return (
        <div style={{ ...base, backgroundColor: '#F3E8FF', color: '#7C3AED' }}>
          ⚡ 18V Member
        </div>
      );
    default:
      return null;
  }
}
